module.exports = __webpack_public_path__ + "img/qingshe.47472daf.png";